import { GoalType } from '@griply/types';
import { filterGoalsBySearchText, filterGoalsByType } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useMemo } from 'react';

export const useTextFilteredGoals = (searchText: string, types: GoalType[]) => {
  const goals = useGoals();

  return useMemo(
    () => filterGoalsBySearchText(filterGoalsByType(goals, types), searchText),
    [searchText, goals, types],
  );
};
